import { ActionFunction, replace } from 'react-router-dom';
import { client } from '~/api/client';
import { mutateData } from '~/api/data/request';
import { submitMutation } from '~/api/data/responses';
import {
  CreateKnowledgeBaseTextDocumentDocument,
  CreateKnowledgeBaseTextDocumentMutation,
  CreateKnowledgeBaseTextDocumentMutationVariables,
  DeleteKnowledgeBaseDocumentDocument,
  DeleteKnowledgeBaseDocumentMutation,
  DeleteKnowledgeBaseDocumentMutationVariables,
  UpdateKnowledgeBaseDocumentDocument,
  UpdateKnowledgeBaseDocumentMutation,
  UpdateKnowledgeBaseDocumentMutationVariables,
  UploadKnowledgeBaseFileDocumentDocument,
  UploadKnowledgeBaseFileDocumentMutation,
  UploadKnowledgeBaseFileDocumentMutationVariables
} from '~/api/graphql';

export const createKnowledgeBaseTextDocument = (
  variables: CreateKnowledgeBaseTextDocumentMutationVariables
) =>
  mutateData<
    CreateKnowledgeBaseTextDocumentMutation,
    CreateKnowledgeBaseTextDocumentMutationVariables
  >(client, {
    mutation: CreateKnowledgeBaseTextDocumentDocument,
    variables
  });

export const uploadKnowledgeBaseFileDocument = (
  variables: UploadKnowledgeBaseFileDocumentMutationVariables
) =>
  mutateData<
    UploadKnowledgeBaseFileDocumentMutation,
    UploadKnowledgeBaseFileDocumentMutationVariables
  >(client, {
    mutation: UploadKnowledgeBaseFileDocumentDocument,
    variables
  });

export const updateKnowledgeBaseDocument = (
  variables: UpdateKnowledgeBaseDocumentMutationVariables
) =>
  mutateData<UpdateKnowledgeBaseDocumentMutation, UpdateKnowledgeBaseDocumentMutationVariables>(
    client,
    {
      mutation: UpdateKnowledgeBaseDocumentDocument,
      variables
    }
  );

export const deleteKnowledgeBaseDocument = (
  variables: DeleteKnowledgeBaseDocumentMutationVariables
) =>
  mutateData<DeleteKnowledgeBaseDocumentMutation, DeleteKnowledgeBaseDocumentMutationVariables>(
    client,
    { mutation: DeleteKnowledgeBaseDocumentDocument, variables }
  );

export const submitUploadKnowledgeBaseFileDocument: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  return submitMutation(
    uploadKnowledgeBaseFileDocument({
      knowledgeBaseId: formData.get('knowledgeBaseId') as string,
      input: {
        files: formData.getAll('files') as File[],
        folderId: (formData.get('folderId') as string | null) || null
      }
    })
  );
};

export const submitCreateKnowledgeBaseTextDocument: ActionFunction = async ({ params, request }) =>
  submitMutation(
    createKnowledgeBaseTextDocument({
      knowledgeBaseId: params.knowledgeBaseId || '',
      input: await request.json()
    }),
    async (data) =>
      replace(
        `/app/knowledge/${params.knowledgeBaseId}/${data?.createKnowledgeBaseTextDocument?.id}`
      )
  );

export const submitDeleteKnowledgeBaseDocument: ActionFunction = async ({ params }) =>
  submitMutation(deleteKnowledgeBaseDocument({ id: params.documentId || '' }), async () =>
    replace(`/app/knowledge/${params.knowledgeBaseId}`)
  );

export const submitUpdateKnowledgeBaseDocument: ActionFunction = async ({ params, request }) =>
  submitMutation(
    updateKnowledgeBaseDocument({
      id: params.documentId || '',
      input: await request.json()
    }),
    async (data) =>
      replace(`/app/knowledge/${params.knowledgeBaseId}/${data?.updateKnowledgeBaseDocument?.id}`)
  );
